import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React, { useEffect, useState } from "react";
import ParkingHistoryCard from "../../Cards/ParkingHistoryCard/ParkingHistoryCard";
import classes from "../Accordion.module.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ParkingCostDetailsCard from "../../Cards/ParkingCostDetailsCard/ParkingCostDetailsCard";

const ParkingHistoryAccordion = (props) => {
  const [expanded, setExpanded] = React.useState("");
  const [isHover, setIsHover] = useState(false);

  const isCheckedClass = isHover
    ? `${classes.accordionSummary} ${classes.hover}`
    : `${classes.accordionSummary}`;
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleCheck = (value) => {
    setExpanded(false);
    props.handleActionChange(value);
  };

  return (
    <div className={classes.cardContainer}>
      <Accordion
        defaultExpanded
        className={classes.accordion}
        expanded={expanded === props.parkingHistory.id}
        onChange={handleChange(props.parkingHistory.id)}
      >
        <AccordionSummary
          aria-controls={props.parkingHistory.id}
          id={props.parkingHistory.id}
          className={isCheckedClass}
          expandIcon={<ExpandMoreIcon />}
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() =>
            setIsHover(false || props.checkedList[props.parkingHistory.id])
          }
        >
          <ParkingHistoryCard
            {...props}
            expanded={expanded}
            isHover={isHover}
            checkedList={props.checkedList}
            handleCheck={handleCheck}
            getSelectedValues = {props.getSelectedValues}
          ></ParkingHistoryCard>
        </AccordionSummary>

        <AccordionDetails className={classes.accordionDetails}>
          <ParkingCostDetailsCard {...props}></ParkingCostDetailsCard>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ParkingHistoryAccordion;
